<div class="route-component">
    <div class="search-component">
        <h4>
            Ageing Listings
        </h4>

        <div class="line-connector"></div>

        <div class="action-bar">
            <div class="action-bar right">
                <div class="action-container">
                    <button *hasPermission="['Ageing', 'Import']" (click)="createAgeingBatch()">
                        Import New Batch <i class="fas fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>

        <div class="search-bar">
            <div class="search-bar left">
                <div class="search-container">

                    <auto-complete-dropdown
                        [type]="'status'"
                        [options]="statusOptions"
                        [initialValue]="selectedStatus ? 1 : 0"
                        [displayWith]="displayStatus"
                        (selectionChange)="onStatusSelectionChange($event)">
                    </auto-complete-dropdown>

                    <auto-complete-dropdown
                        *ngIf="selectedPeriodId"
                        [type]="'period'"
                        [options]="periods"
                        [placeholder]="'Select a period...'"
                        [initialValue]="selectedPeriodId"
                        [displayWith]="formatPeriod"
                        (selectionChange)="onPeriodSelectionChange($event)">
                    </auto-complete-dropdown>

                    <input class="search-input" type="text" placeholder="Search..." [(ngModel)]="search" (keydown.enter)="refreshGridData()">

                    <button class="search-button" (click)="refreshGridData()">
                        <i class="fas fa-magnifying-glass"></i>
                    </button>

                </div>
            </div>
        </div>

        <pageable-table
            [items]="batches"
            [paging]="paging"
            [columns]="getColumnMap()"
            (refreshData)="getAgeingBatches($event)"
            [showEdit]="showEdit"
            (editItem)="editAgeingBatch($event)"
            [showDelete]="showDelete"
            (deleteItem)="deleteAgeingBatch($event)">
        </pageable-table>
    </div>
</div>